import React from 'react'
import { Pill } from '../ui'

const CYCLE = [null, 'high', 'medium', 'low']

const TONES = {
  high: 'danger',
  medium: 'info',
  low: 'neutral',
}

export function PriorityTag({ priority, onChange, disabled }) {
  if (!priority && disabled) return null

  function handleClick() {
    if (disabled) return
    const idx = CYCLE.indexOf(priority)
    onChange(CYCLE[(idx + 1) % CYCLE.length])
  }

  if (!priority) {
    return (
      <button
        type="button"
        onClick={handleClick}
        title="Set priority"
        style={{
          fontSize: 9,
          padding: '1px 6px',
          borderRadius: 'var(--radius-pill)',
          border: '1px dashed var(--border)',
          background: 'transparent',
          color: 'var(--text-secondary)',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          fontFamily: 'inherit',
        }}
      >
        priority
      </button>
    )
  }

  return (
    <Pill
      as="button"
      type="button"
      tone={TONES[priority]}
      onClick={handleClick}
      disabled={disabled}
      style={{ fontSize: 9, padding: '1px 6px', flexShrink: 0 }}
    >
      {priority}
    </Pill>
  )
}
